/**
 * @generated SignedSource<<6f11c5c17c8efb08d27639c69653e1e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentAttachmentsSectionFragment$data = {
  readonly attachments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly downloadUrl: string | null;
        readonly id: string;
        readonly mediaUrl: string | null;
        readonly name: string;
        readonly type: string | null;
        readonly videoUrl: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "ContentAttachmentsSectionFragment";
};
export type ContentAttachmentsSectionFragment$key = {
  readonly " $data"?: ContentAttachmentsSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentAttachmentsSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentAttachmentsSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentAttachmentNodeConnection",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentAttachmentNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentAttachment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "downloadUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "videoUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mediaUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": null
};

(node as any).hash = "1c5bb7e2c65f86f8b575b304a3a31f01";

export default node;
